












































import {filterMatchColumns} from '@/helpers';
import {asyncScheduler, combineLatest, from, of} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {tournamentsApi} from '@/api/TournamentsApi';
import {Component, Prop, Vue} from 'vue-property-decorator';
import BlankLoader from '@/components/common/BlankLoader.vue';
import CollapsibleTable from '@/components/common/CollapsibleTable.vue';
import DataTable from '@/components/common/DataTable.vue';
import DataFilter from '@/components/common/DataFilter.vue';
import {
  generateLangSubscriptions,
  observeProp, observeFieldAsUIInput,
  watchAsLoadedObservable,
} from '@/components/observe';

@Component<TournamentPlayers>({
  components: {
    BlankLoader,
    CollapsibleTable,
    DataTable,
    DataFilter,
  },
  subscriptions() {
    const lang$ = observeProp<string>(this, 'lang');
    const isGuest$ = observeProp<boolean>(this, 'isGuest');
    const tournament$ = observeProp<number>(this, 'tournament');
    const approvedTournamentRequests$ = tournament$.pipe(
      switchMap((tournament) => from(tournamentsApi.getTournamentRequests(tournament), asyncScheduler)),
      map((x: any) => x.map((y: any) => y).filter((z: any) => z.isApproved)),
    );
    const playersFilter$ = observeFieldAsUIInput(this, 'playersFilter');

    return Object.assign(generateLangSubscriptions(lang$), {
      players: combineLatest(
        approvedTournamentRequests$,
        playersFilter$,
      ).pipe(
        switchMap(([requests, playersFilter]: any) => of(
          requests.filter((x: any) => this.filterMatch(x, playersFilter)))),
      ),
      isPlayersLoaded: watchAsLoadedObservable(this, 'players'),
      columns: combineLatest(
        of(this.allColumns),
        isGuest$,
      ).pipe(
        switchMap(([allColumns, isGuest]: any) => isGuest ?
          of(allColumns.filter((x: any) => x.name !== 'icq' && x.name !== 'skype' && x.name !== 'discord')) :
          of(allColumns),
        ),
      ),
    });
  },
})
export default class TournamentPlayers extends Vue {
  public allColumns: any[] = [
    {name: 'name', title: 'name', width: '20%'},
    {name: 'date', title: 'date', width: '20%'},
    {name: 'icq', title: 'icq', width: '20%'},
    {name: 'discord', title: 'discord', width: '20%'},
    {name: 'skype', title: 'skype', width: '20%'},
  ];
  public playersFilter = '';

  @Prop() public tournament!: number;
  @Prop() public isGuest!: boolean;

  public filterMatch(player: any, playersFilter: string) {
    return filterMatchColumns(player, playersFilter, [
      'username',
      'date',
      'icq',
      'skype',
      'discord',
    ]);
  }
}
